export enum RosteringProvider {
  CLEVER = 'clever',
  ONE_ROSTER = 'oneroster',
  ONE_ROSTER_SFTP = 'onerostersftp',
  WATERFORD = 'waterford',
}
